const { REACT_APP_ENVIRONMENT, REACT_APP_BASE_URL } = process.env

export const CONFIG = {
    ENVIRONMENT: REACT_APP_ENVIRONMENT,
    BASE_URL: REACT_APP_BASE_URL,
}

export const SIZES = {
    XS: 'xs',
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
}

export const CONTROL_SIZES = {
    [SIZES.XS]: 7,
    [SIZES.SM]: 9,
    [SIZES.MD]: 11,
    [SIZES.LG]: 14,
}

export const LAYOUT = {
    HORIZONTAL: 'horizontal',
    VERTICAL: 'vertical',
    INLINE: 'inline',
}

export const DIRECTIONS = {
    TOP: 'top',
    RIGHT: 'right',
    BOTTOM: 'bottom',
    LEFT: 'left',
}

export const SELECTION_MODES = {
    YEAR: 'year',
    MONTH: 'month',
    DAY: 'day',
}

export const PICKER_VIEWS = {
    YEAR: 'year',
    MONTH: 'month',
    DATE: 'date',
}

export const STATUS = {
    DANGER: 'danger',
    SUCCESS: 'success',
    WARNING: 'warning',
    ACCEPTED: 'accepted',
    PENDING: 'pending',
    VERIFIED: 'verified',
    INFO: 'info',
}

export const STEPS_STATUS = {
    COMPLETE: 'complete',
    PENDING: 'pending',
    IN_PROGRESS: 'in-progress',
    ERROR: 'error',
}

export const PLACEMENT = {
    TOP_START: 'top-start',
    TOP_CENTER: 'top-center',
    TOP_END: 'top-end',
    BOTTOM_START: 'bottom-start',
    BOTTOM_CENTER: 'bottom-center',
    BOTTOM_END: 'bottom-end',
    MIDDLE_START_TOP: 'middle-start-top',
    MIDDLE_START_BOTTOM: 'middle-start-bottom',
    MIDDLE_END_TOP: 'middle-end-top',
    MIDDLE_END_BOTTOM: 'middle-end-bottom',
}

export const DROPDOWN_ITEM_TYPE = {
    DEFAULT: 'default',
    HEADER: 'header',
    DIVIDER: 'divider',
    CUSTOM: 'custom',
}

export const DAY_DURATION = 86400000

export const COLORS = {
    THEME_COLOR: '#0280C7',
    THEME_DARK_COLOR: '#014D77',
    THEME_BORDER_COLOR: '#E2E2E2',
    THEME_BORDER_LIGHT_COLOR: '#CCE6F4',
    THEME_BG_LIGHT_COLOR: '#F2F8FC',
    WHITE: '#FFFFFF',
    BUTTON_COLOR: '#0084c7',
    TOOLTIP_BUTTON_COLOR: '#003769',
    TABLECELL_DAYS_COLOR: '#EB4747',
    ACCEPTED_COLOR: '#81DE64',
    ACCEPTED_BG_COLOR: '#E0F9E2',
    PENDING_COLOR: '#FCC878',
    PENDING_BG_COLOR: '#F9F2E0',
    EDIT_COLOR: '#0068A3',
    INITIAL_CIRCLE_COLOR: '#9ACCE9',
    PENDING_TEXT_COLOR: '#FEB343',
    REJECT_BG_COLOR: '#F9E0E0',
    REJECT_TEXT_COLOR: '#EB4747',
    APPROVED_BG_COLOR: '#E0F9E2',
    APPROVED_TEXT_COLOR: '#30AB30',
    CheckCircle_OutlineSharp_Icon: '#41B241',
    Highlight_OffSharp_Icon: '#ED5D5D',
    ASTERISK: '#EB4747',
    ADMIN: '#676767',
}

export const CONFIG_VALS = {
    GST: 15,
    OTP_TIMER: '60',
    PAN: 10,
    CIN: 21,
    IFSC: 11,
    SWIFT_BIC_MIN: 8,
    SWIFT_BIC_MAX: 11,
}

export const ALLOWED_FILE_TYPES = {
    IMAGES: ['image/jpeg', 'image/png'],
    PDF: ['application/pdf'],
    DOC: ['application/doc', 'application/docx'],
    EXCEL: ['application/xls', 'application/xlsx'],
}

export const WINDOW_WIDTH = {
    SCREEN_1300: 1300,
    SCREEN_1400: 1400,
    SCREEN_1600: 1600,
    SCREEN_1900: 1900,
}

export const [IN_PROGRESS, DRAFT, SUCCESS, FAILED] = [
    'In Progress',
    'DRAFT',
    'Success',
    'Failed',
]

export const [
    PENDING,
    APPROVED,
    REJECTED,
    SUBMITTED,
    PENDING_FOR_VERIFICATION,
    VERIFIED,
    All,
    verified,
    DECLINED,
] = [
    'Pending',
    'Approved',
    'Rejected',
    'Submitted',
    'Pending for Verification',
    'Verified',
    'All',
    'verified',
    'Declined',
]

export const ROLES = {
    SELLER_ADMIN: 'ROLE_SELLER_ADMIN',
    SELLER_MEMBER: 'ROLE_SELLER',
    OPERATOR: 'ROLE_SUPER_ADMIN',
}

export const ROLES_MAPPING = {
    ROLE_SELLER_ADMIN: 'Seller Admin',
    ROLE_SELLER: 'Seller',
    ROLE_SUPER_ADMIN: 'Operator',
}

export const ORDER_STATUS = {
    pendingAction: 'Pending Action',
    accepted: 'Accepted',
    partiallyAccepted: 'Partially Accepted',
    awaitingShipment: 'Awaiting Shipment',
    declined: 'Declined',
    cancelled: 'Cancelled',
    shipped: 'Shipped',
    partiallyShipped: 'Partially Shipped',
    deliveryAttempt: 'Delivery Attempt',
    grnReceived: 'GRN Received',
    completed: 'Completed',
    partiallyCompleted: 'Partially Completed',
}
export const [DELETE, APPROVE, ADD] = ['Delete', 'Approve', 'Add']

export const CURRENCY = {
    INR: '₹',
    DOLLER: '$',
}

export const CURRENCY_CODE = {
    INR: 'INR',
    DOLLER: 'USD',
}
